import { ROUTES } from '@shared/utils';

type MagazinePageHrefContext = { type: 'home' } | { type: 'category'; categorySlug: string } | { type: 'author'; authorSlug: string } | { type: 'search'; query: string };

function replaceRouteParam(path: string, param: string, value: string): string {
  return path.replace(`:${param}`, encodeURIComponent(value));
}

function buildPathPageHref(basePath: string, paginatedPath: string, page: number, slugParam?: { name: string; value: string }): string {
  if (page <= 1) {
    return slugParam ? replaceRouteParam(basePath, slugParam.name, slugParam.value) : basePath;
  }

  let path = paginatedPath;

  if (slugParam) {
    path = replaceRouteParam(path, slugParam.name, slugParam.value);
  }

  return replaceRouteParam(path, 'pageNumber', String(page));
}

function buildSearchPageHref(query: string, page: number): string {
  return `${ROUTES.MAGAZINE.SEARCH}?${new URLSearchParams({ q: query, page: String(page) })}`;
}

function assertNever(context: never): never {
  throw new Error(`Unhandled magazine page href context type: ${JSON.stringify(context)}`);
}

function buildMagazinePageHref(context: MagazinePageHrefContext, page: number): string {
  switch (context.type) {
    case 'home':
      return buildPathPageHref(ROUTES.MAGAZINE.HOME, ROUTES.MAGAZINE.HOME_WITH_PAGE_NUMBER, page);
    case 'category':
      return buildPathPageHref(ROUTES.MAGAZINE.CATEGORY, ROUTES.MAGAZINE.CATEGORY_WITH_PAGE_NUMBER, page, {
        name: 'categorySlug',
        value: context.categorySlug,
      });
    case 'author':
      return buildPathPageHref(ROUTES.MAGAZINE.AUTHOR, ROUTES.MAGAZINE.AUTHOR_WITH_PAGE_NUMBER, page, {
        name: 'authorSlug',
        value: context.authorSlug,
      });
    case 'search':
      return buildSearchPageHref(context.query, page);
    default:
      return assertNever(context);
  }
}

export { buildMagazinePageHref, type MagazinePageHrefContext };
